module.exports = __webpack_public_path__ + "static/media/logos_meta-icon.2a7e22e1.svg";